import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {ArticoloNcCounter, QualitaStatisticheStat} from '../../_models/QualitaStatisticheStat';

/** Feature 161 (B2): controlli qualità degli ultimi 30 giorni. */
@Component({
  selector: 'app-dashboard-qualita',
  templateUrl: './dashboard-qualita.component.html',
  styleUrls: ['../dashboard-widget.scss', './dashboard-qualita.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, IonicModule]
})
export class DashboardQualitaComponent {
  /** null senza errore = caricamento. */
  @Input()
  set stat(stat: QualitaStatisticheStat | null) {
    this._stat = stat;
    this.percentuale = Math.round(Math.min(100, Math.max(0, stat?.percentualeConformi ?? 0)));
    this.sfondoAnello =
      `conic-gradient(var(--ion-color-success) 0 ${this.percentuale}%, var(--ion-color-danger) 0 100%)`;
    this.topArticoli = (stat?.topArticoliNc ?? []).slice(0, 5);
  }

  get stat(): QualitaStatisticheStat | null {
    return this._stat;
  }

  @Input() errore = false;

  /** Calcolati una volta per input, non a ogni change detection (vedi `DashboardStatoMacchineComponent`). */
  percentuale = 0;
  sfondoAnello = '';
  topArticoli: ArticoloNcCounter[] = [];
  private _stat: QualitaStatisticheStat | null = null;
}
